import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Event } from 'baseline-lib';
import { SharedService } from 'baseline-lib';


/**
 * Generated class for the FastCodesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fast-codes',
  templateUrl: 'fast-codes.html',
})
export class FastCodesPage {
  data:any;
  fastCodes : Event ;


  constructor(public navCtrl: NavController, public navParams: NavParams, private _sharedService : SharedService,) {
    this.data = this.navParams.get('dataz');
  }

  ngOnInit() {
    console.log('ionViewDidLoad FastCodesPage');

        this.fastCodes = new Event();

        var e = new Event();
        e.constructEvent(this.data,this._sharedService.selectedGameType.gtid)
        this.fastCodes = e;
        let text = 
        '<style>.box,.flex{display:flex}.header,.scode{font-weight:700}.scode,.selection-name{border-bottom:1px solid #dcdcdc}.wrapper{background-color:#fff;font-size:11px}.column{padding-right:0;padding-left:8px}.box{flex-wrap:wrap}.box>*{flex:1 1 40%}.marketDiv{border:1px solid #dcdcdc}.header{width:100%;background-color:#a9a9a9;color:#000;text-align:center;font-size:13px;padding:1px}.selection-name{width:60%;text-align:left;padding-left:10px;word-wrap:break-word}.scode{width:40%;text-align:right;color:red}</style>'
        +
        ' <div class="wrapper">'+
        ' <div class="box" > ';

        this.fastCodes.mli.forEach(market => {
        // market.mn.replace('&','') 
          text += '<div  class=" column" >'+ 
          ' <div class="marketDiv">'+
          ' <div class="header">'+ market.mn +' </div>';

            market.sli.forEach(sel => {
              text += '<div>' +
              '<table style="width:100%">'+
              ' <tr>'+
              '<td class="scode">'+sel.ucd +' </td>'+ '<td class="selection-name">'+sel.sn+ '</td>'+
              ' </tr>'+
              '</table>'+
              ' </div>' ;
            });

            text +=  ' </div>'+
            '  </div>';
        });
        text +=  ' </div>'+
        '  </div>';
        document.getElementById('fast_code_div').innerHTML += text;
        // this.win1.document.body.innerHTML = text;
  }

}



// WEBPACK FOOTER //
// ./src/app/sports/fast-codes/fast-codes.ts